import { Link } from "react-router-dom";
import { Mailbox } from "lucide-react";

export const Logo = ({ light = false, to = "/" }) => (
  <Link to={to} data-testid="brand-logo" className="inline-flex items-center gap-2 group">
    <span className="h-8 w-8 rounded-lg bg-emerald-600 text-white inline-flex items-center justify-center group-hover:rotate-[-6deg] transition-transform">
      <Mailbox size={17} />
    </span>
    <span className={`font-display font-bold text-lg tracking-tight ${light ? "text-white" : "text-slate-900 dark:text-white"}`}>
      Postal<span className="text-emerald-600">Cloud</span>
    </span>
  </Link>
);
